import { RouteName, RoutePath, ScreenName } from 'view/common/constants';
import type { PaperAppearance } from 'view/layout/paper';
import { AsyncCsmRequestDetails } from '@atlassian/csm-request-details/src/ui/index';
import { CsmRequestsList } from '@atlassian/csm-requests-list';
import { createRouteWithLayout } from '@atlassian/help-center-common-util/resource-router';

export const csmRequestsListRoute = createRouteWithLayout(
    {
        resources: [],
        name: RouteName.CSM_REQUESTS_LIST_PAGE,
        path: RoutePath.CSM_REQUESTS_LIST_PATH,
        exact: true,
        component: CsmRequestsList,
    },
    ScreenName.CSM_REQUESTS_LIST,
    {
        isAnonymous: false,
        paperAppearance: 'xxwide' as PaperAppearance,
        fadeInSearchModal: true,
        prefetchBrandingModel: true,
    }
);

export const csmRequestDetailsRoute = createRouteWithLayout(
    {
        resources: [],
        name: RouteName.CSM_REQUEST_DETAILS_PAGE,
        path: RoutePath.CSM_REQUEST_DETAILS_PATH,
        exact: true,
        component: AsyncCsmRequestDetails,
    },
    ScreenName.CSM_REQUEST_DETAILS,
    {
        isAnonymous: false,
        paperAppearance: 'xxwide' as PaperAppearance,
        fadeInSearchModal: true,
        prefetchBrandingModel: true,
        hideBanner: true,
    }
);
